(function () {
  'use strict';

  var modal = document.getElementById('notify-me-modal');
  if (!modal) return;

  var tagsInput = modal.querySelector('[name="contact[tags]"]');
  var data = window.__notifyMeData || {};
  var variants = data.variants || [];

  // ── Modal ─────────────────────────────────────────────────────

  function openModal(size) {
    if (tagsInput) {
      var handle = data.productHandle || '';
      var tag = 'notify-' + handle;
      if (size) tag += '-' + size.toLowerCase().replace(/[\s\/]+/g, '-');
      tagsInput.value = tag;
    }
    modal.showModal();
  }

  function closeModal() { modal.close(); }

  var closeBtn = document.getElementById('notify-modal-close');
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

  // Event delegation — works even after section re-renders replace the button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-notify-open]');
    if (btn) openModal(btn.dataset.notifySize || '');
  });

  // ── Success toast ─────────────────────────────────────────────

  var params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    showToast("You're on the list! We'll notify you when it's available.");
    var url = new URL(window.location.href);
    url.searchParams.delete('customer_posted');
    window.history.replaceState({}, '', url.toString());
  }

  function showToast(message) {
    var toast = document.createElement('div');
    toast.className = 'notify-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('notify-toast--visible'); });
    });
    setTimeout(function () {
      toast.classList.remove('notify-toast--visible');
      setTimeout(function () { toast.remove(); }, 400);
    }, 4000);
  }

  // ── Default product page only ─────────────────────────────────
  // Coming-soon page has no .buy-buttons-block — skip all visibility logic.
  // The notify button there is always visible from the template HTML.

  var buyBlock = document.querySelector('.buy-buttons-block');
  if (!buyBlock) return;

  var debounceTimer;

  function syncNotifyBtn() {
    var notifyBtn = document.getElementById('product-notify-btn');
    // Re-query add-to-cart each time — section re-renders replace the element
    var addToCartBtn = buyBlock.querySelector('button[name="add"]');
    if (!notifyBtn || !addToCartBtn) return;

    // Sync the size tag for the modal
    var input = document.querySelector('input[name="id"]');
    if (input && variants.length) {
      var id = parseInt(input.value);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) { notifyBtn.dataset.notifySize = variants[i].title; break; }
      }
    }

    // addToCartBtn.disabled is the single source of truth the theme uses
    if (addToCartBtn.disabled) {
      notifyBtn.removeAttribute('hidden');
    } else {
      notifyBtn.setAttribute('hidden', '');
    }
  }

  function debouncedSync() {
    clearTimeout(debounceTimer);
    // 150ms debounce skips temporary disabled states during theme transitions
    debounceTimer = setTimeout(syncNotifyBtn, 150);
  }

  // Watch the add-to-cart button's disabled attribute for JS-driven changes
  function attachButtonObserver() {
    var addToCartBtn = buyBlock.querySelector('button[name="add"]');
    if (!addToCartBtn) return;
    new MutationObserver(debouncedSync).observe(addToCartBtn, {
      attributes: true,
      attributeFilter: ['disabled']
    });
  }

  // Watch buy-block for section re-renders (new HTML replaces old)
  new MutationObserver(function () {
    // After re-render: re-attach observer to the new button, then sync
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      attachButtonObserver();
      syncNotifyBtn();
    }, 50);
  }).observe(buyBlock, { childList: true });

  attachButtonObserver();
  syncNotifyBtn();
})();
